module.exports = __webpack_public_path__ + "static/media/placeholder.carousel.f9965ff8.png";